import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { LtiAccountListItem } from "../types";

const LtiAccountRow: React.FC<{ item: LtiAccountListItem }> = ({ item }) => {
  const theme = useTheme();

  const meta = [
    `ID: ${item.idCorporateAccount}`,
    item.deploymentId,
    item.launchRequestUrl,
  ]
    .filter(Boolean)
    .join(" | ");

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
      <Typography
        sx={{
          fontSize: "14px",
          fontWeight: 700,
          color: theme.palette.text.primary,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {item.accountName}
      </Typography>
      <Typography
        sx={{
          fontSize: "12px",
          color: theme.palette.text.tertiary,
          lineHeight: 1.4,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {meta}
      </Typography>
    </Box>
  );
};

export default LtiAccountRow;
